import { render, staticRenderFns } from "./DeliveryAreas.vue?vue&type=template&id=63032f12&"
import script from "./DeliveryAreas.vue?vue&type=script&lang=js&"
export * from "./DeliveryAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports